import { modalFooterCss } from "./ExportablesModalFooter.styles";
import StudentActions from "./StudentActions";
import TeacherActions from "./TeacherActions";

interface ExportablesModalFooterProps {
  isStudent?: boolean;
}

const ExportablesModalFooter = ({
  isStudent = false,
}: ExportablesModalFooterProps) => {
  return (
    <div css={modalFooterCss}>
      {isStudent ? <StudentActions /> : <TeacherActions />}
    </div>
  );
};

export default ExportablesModalFooter;
